import React, { FC } from 'react';

type AppLayoutTopProps = {
  title: string;
  children?: React.ReactNode;
};

const AppLayoutTop: FC<AppLayoutTopProps> = (props) => {
  return (
    <div className="layout-flex">
      <h2 className={'layout-flex__title'}>{props.title}</h2>
      <div className="layout-flex__right">{props.children}</div>
    </div>
  );
};

export default AppLayoutTop;
